import { render, staticRenderFns } from "./logwood-package-state-select.vue?vue&type=template&id=8f2a7e2a&scoped=true&"
import script from "./logwood-package-state-select.vue?vue&type=script&lang=ts&"
export * from "./logwood-package-state-select.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f2a7e2a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
